import { render, staticRenderFns } from "./ProductWindow.vue?vue&type=template&id=147ecbd2&scoped=true"
import script from "./ProductWindow.vue?vue&type=script&lang=js"
export * from "./ProductWindow.vue?vue&type=script&lang=js"
import style0 from "./ProductWindow.vue?vue&type=style&index=0&id=147ecbd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147ecbd2",
  null
  
)

export default component.exports